// questionSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getQuestions } from "../api/question";
import { getPassage } from "../api/passage";

export const fetchQuestions = createAsyncThunk(
  "questions/fetchQuestions",
  async ({ passageId }, { dispatch }) => {
    try{
      const passage = await getPassage(passageId);
      const passageData = passage.data.data.prompt;
      dispatch(setPassage(passageData));
      const response = await getQuestions(passageId);
      const data = response.data.data;
      return data;
      
    }catch(error){
      console.log(`${error}`)
    }

  }
);

const questionsSlice = createSlice({
  name: "questions",
  initialState: {
    questions: [],
    loading: true, // Initialize loading state
    passage: "",
  },
  reducers: {
    setPassage: (state, action) => {
      state.passage = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchQuestions.pending, (state) => {
        state.loading = true; // Set loading to true while fetching
      })
      .addCase(fetchQuestions.fulfilled, (state, action) => {
        const questions = action.payload;
        state.questions = questions;
        state.loading = false;
      });
  },
});

export const { setPassage }  = questionsSlice.actions;
export default questionsSlice.reducer;
